import React from 'react';
import Accordian from '../../../components/accordion/accordion';
import {faq} from '../data/data';

const Faq = () => {
  return (
    <div className='flex flex-col gap-5 heading-24'>FAQs
      {faq.map((item,index) => (
        <Accordian
          kay={index}
          title={item.title}
          content={item.content}
          width={'100%'}
        />
      ))}
      
    </div>
    
  )
}

export default Faq